// src/com/file_of_report/TransPlanResultReportGql.js
import { gql } from "@apollo/client";

/*
# 레포트 생성 관련하여 여러 곳에서 공통으로 사용하는 FileCreateHisItem 및 ResponseWithFileCreateHisItem
type FileCreateHisItem {
	fileCreateHisSeq: Int!
	dcCd: String
	fileDownUp: String
	fileFlag: String
	menuName: String
	serverUrl: String
	fileAddr: String
	fileTitle: String
	fileName: String
	fileSize: Int
	fileExt: String
	regUser: String
	regDate: String
	regUserName: String
}

type ResponseWithFileCreateHisItem {
	ok: Boolean!
	message: String
	item: FileCreateHisItem
}


extend type Mutation {
    transPlanResultReportAdd(transPlanResultReport: InputTransPlanResultReportAdd!): ResponseWithFileCreateHisItem!
}

# 운송사가 아닌 경우의 운송결과 레포트 조회용 입력
input InputTransPlanResultReportAdd {
    dateFrom: String!
    dateTill: String!
	dcCd: String
    transTypeCd: String
    vehTypeId: String
    comId: String
    storeId: String
    vehPlates: String
}
*/

export const CREATE_TRANS_PLAN_RESULT_REPORT = gql`
mutation CreateTransPlanResultReport($transPlanResultReport:InputTransPlanResultReportAdd!) {
    transPlanResultReportAdd(transPlanResultReport: $transPlanResultReport) {
        ok
        message
        item {
            fileCreateHisSeq
        }
    }
}
`;
